import { useEffect, useState } from 'react';
import lodashSet from 'lodash.set';
import { QuestionnaireFormSection } from '../../../../../../features/QuestionnaireFormSection';
import { useUpdateStructure } from '../../../../../../hooks/useUpdateStructure';
import { useLocalization } from '../../../../../../../../../../../../lib/hooks/useLocalization';
import { PrefillFields } from '../../../../../../../../../../../../lib/models/Questionnaire';
import {
  formatExternalPrefillIdsForInput,
  parseExternalPrefillIdsFromInput,
} from '../../../../../../../../features/DraggableFormRow/lib/external-prefill-ids';

const toInputValue = value => formatExternalPrefillIdsForInput(parseExternalPrefillIdsFromInput(value));

/**
 * The structure keeps the parsed list of codes, which has no room for the comma typed on the way to the
 * next code. The raw text therefore lives here and is replaced only when the stored list really changes
 * (undo, another tab, a loaded version).
 */
export function CounterPrefillIdsField({ value, dataPath, disabled }) {
  const { counterPrefillIds } = useLocalization().translations.unique.formItems;
  const { updateStructure } = useUpdateStructure();
  const storedValue = formatExternalPrefillIdsForInput(value);
  const [inputValue, setInputValue] = useState(storedValue);

  useEffect(() => {
    setInputValue(current => (toInputValue(current) === storedValue ? current : storedValue));
  }, [storedValue]);

  const handleChange = event => {
    const nextValue = event.target.value;

    setInputValue(nextValue);
    updateStructure(draft => {
      lodashSet(draft, `${dataPath}.${PrefillFields.COUNTER_PREFILL_IDS}`, parseExternalPrefillIdsFromInput(nextValue));
    });
  };

  return <QuestionnaireFormSection textFieldProps={{ label: counterPrefillIds.label, value: inputValue, onChange: handleChange, disabled }} />;
}
